import { DataTable } from '@fluentsms/agentnet-web-components';
import { makeStyles } from '@material-ui/core';
import { FilterChangedEvent, GridApi, GridReadyEvent, RowClickedEvent } from 'ag-grid-enterprise';
import { AgGridReactProps } from 'ag-grid-react';
import React, { forwardRef, MutableRefObject, useCallback, useRef } from 'react';

const useStyles = makeStyles(() => ({
  withSkeleton: {
    '& .ag-overlay': {
      position: 'relative',
    },
    '& .ag-overlay-wrapper': {
      display: 'block',
    },
  },
}));

export type GridDefaultDimensions = {
  width: string;
  height: string;
  minWidth?: string;
};

const GRID_DEFAULT_DIMENSIONS = {
  width: `100%`,
  height: '400px',
};

/*
  NOTE: Use HOC enhancers to add functionality to the grid
  This component should only get AgGridReactProps as props
*/
export interface DataGrableProps {
  title: React.ReactNode;
  rowData: any[];
  gridConfig: AgGridReactProps;
  gridDefaultDimensions?: GridDefaultDimensions;
  HeaderBar?: React.ReactNode;
  onGridReady?: (params: GridReadyEvent) => void;
  onFilterChanged?: (event: FilterChangedEvent) => void;
  onRowClicked?: (event: RowClickedEvent) => void;
  gridApiRef?: MutableRefObject<GridApi> | null;
  overrideClasses?: Record<string, string>;
  context?: any;
  loading?: boolean;
}

export const DataGrableBase = forwardRef<HTMLDivElement, DataGrableProps>((props, ref) => {
  const classes = useStyles();
  const gridWrapperRef = useRef<null | HTMLDivElement>(null);
  const { gridConfig, gridApiRef = null, onGridReady = null, rowData, context } = props;
  const handleGridReady = useCallback((params: GridReadyEvent) => {
    if (gridApiRef && params.api) {
      gridApiRef.current = params.api;
    }

    onGridReady?.(params);
  }, []);

  return (
    <div
      ref={ref || gridWrapperRef}
      className={`${props.overrideClasses ? props.overrideClasses : ''}`}
      style={{ ...GRID_DEFAULT_DIMENSIONS, ...props.gridDefaultDimensions }}
    >
      <DataTable
        className={props.loading ? classes.withSkeleton : ''}
        onGridReady={handleGridReady}
        onFilterChanged={props.onFilterChanged}
        onRowClicked={props.onRowClicked}
        maintainColumnOrder={true}
        popupParent={document.body}
        rowData={rowData}
        context={context}
        animateRows={false}
        loading={props.loading}
        {...gridConfig}
      />
    </div>
  );
});

DataGrableBase.displayName = 'DataGrable';

export const DataGrable = DataGrableBase;
